import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["width", "height"]


const __default__ = {};

interface Props {
  width?: number;
  height?: number;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IconRedCard',
  props: {
    width: { default: 8 },
    height: { default: 11 }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.width,
    height: _ctx.height,
    viewBox: `0 0 ${_ctx.width} ${_ctx.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("rect", {
      x: "0.180664",
      y: "0.092041",
      width: _ctx.width,
      height: _ctx.height,
      rx: "1.4335",
      fill: "#E11D23"
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})